import script from "./AddPropertyDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddPropertyDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AddPropertyDialog.vue?vue&type=style&index=0&id=25c96f72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c96f72"]])

export default __exports__